import {
  validateBasicInfo,
  validatePreFlow,
  validateScan,
  validatePostFlow,
  extractItemsByKeys,
  prepareForValidation,
  extractWebhook,
  mapFilterRequest
} from './validate'
import {
  WEBHOOKS,
  COOKIES,
  COOKIE_KEYS,
  SCAN_NAME_FIELD,
  USER_KEYS,
  LABELS,
  LABEL_KEYS,
  FLOWS,
  FLOW_KEYS,
  WEBHOOK_KEYS,
  SCAN_TYPE,
  SCAN_TYPE_FULL,
  SCAN_TYPE_CUSTOM,
  SCAN_TYPE_FLOW,
  SCAN_PREFIX,
  RESTRICTIONS_FIELD_NAME,
  FULL_SCAN_ROOT_URL_FIELD,
  FULL_SCAN_COUNT_FIELD,
  CUSTOM_SCAN_FIELD,
  FLOW_SCAN_KEYS,
  RULES,
  RULE_NAME,
  RULE_TRIGGER,
  RULE_FILTERS,
  RULE_ACTION_TYPE_EMAIL,
  RULE_ACTION_TYPE_WEBHOOK,
  RULE_WEBHOOK_KEYS,
  RULE_WEBHOOK_PREFIX,
  RULE_ACTION_EMAIL_VALUE,
  BASIC_INFO,
  PRE_SCAN,
  SCAN,
  POST_SCAN,
  NEW_PREFIX,
  SCAN_PARAMETERS_FLAG_FIELD,
  SCAN_PARAMETERS,
  MOBILE_VIEWPORT
} from 'views/ScanSettings/NewScan/constants'
import { formatWebhooksHeaders } from './utils';

export default [
  {
    name: BASIC_INFO,
    title: 'BASIC INFO',
    validate: validateBasicInfo
  },
  {
    name: PRE_SCAN,
    title: 'PRE SCAN'
  },
  {
    name: SCAN,
    title: 'SCAN',
    validate: validateScan
  },
  {
    name: POST_SCAN,
    title: 'POST SCAN'
  }
]


const extractLists = (list, ListKeys) => {
  let newItems = extractItemsByKeys(list, ListKeys)
  let userItems = extractItemsByKeys(list, USER_KEYS)
  newItems = newItems ? prepareForValidation(newItems) : []
  userItems = userItems ? userItems.map(item => item.id) : []
  return { newItems, userItems }
}

const pushOrCreateKey = (obj, key, values) => {
  if (obj[key]) 
    obj[key] = obj[key].concat(values)
  else 
    obj[key] = values
}

const verifyAndHandleErrors = (payload, responseData) => {
  let isFailed = false
  if (responseData.Errors && !!responseData.Errors.length) {
    isFailed = true
    pushOrCreateKey(payload, 'errors', responseData.Errors)
  }
  return isFailed
}

const flowEnableParameters = (payload, newItem, keyToUpdate) => {
    if(payload[SCAN_PARAMETERS]){
      newItem[SCAN_PARAMETERS] = true;
    }
    else{
      payload[SCAN_PARAMETERS] = newItem[SCAN_PARAMETERS];
      if(keyToUpdate && payload[keyToUpdate]){
        payload[keyToUpdate][SCAN_PARAMETERS] = newItem[SCAN_PARAMETERS];
      }
    }
    return payload
}

const mapRestrictions = (restrictions, values, payload) => {
  let userRestrictions = restrictions.map(r => r.restriction)
  let newRestrictions = { restrictions: [] }
  let existingRestrictions = []
  if (values[RESTRICTIONS_FIELD_NAME]) {
    values[RESTRICTIONS_FIELD_NAME].forEach(r => {
      if (!userRestrictions.includes(r)) newRestrictions.restrictions.push(r)
      else if (userRestrictions.includes(r)) existingRestrictions.push(restrictions.find(f => f.restriction == r).id)
    })
  }

  if (userRestrictions && userRestrictions.length) {
    pushOrCreateKey(payload, `restrictions`, existingRestrictions)
  }

  if (newRestrictions && newRestrictions.restrictions.length) {
    pushOrCreateKey(payload, `${NEW_PREFIX}restrictions`, newRestrictions.restrictions)
  }
}

export const createNewScanPayload = (values, restrictions) => {
  let payload = {};
  payload.name = values[SCAN_NAME_FIELD];
  payload[MOBILE_VIEWPORT] = values[MOBILE_VIEWPORT];
  payload[SCAN_PARAMETERS] = values[SCAN_PARAMETERS_FLAG_FIELD];
  mapRestrictions(restrictions, values, payload);
  
  if (values[COOKIES]) {
    const { newItems, userItems } = extractLists(values[COOKIES], COOKIE_KEYS)
    !!userItems.length && pushOrCreateKey(payload,  `${COOKIES}`, userItems)
    !!newItems.length && pushOrCreateKey(payload, `${NEW_PREFIX}${COOKIES}`, newItems)
  }

  if (values[LABELS]) {
    const { newItems, userItems } = extractLists(values[LABELS], LABEL_KEYS);
    !!userItems.length && pushOrCreateKey(payload, `${LABELS}`, userItems);
    !!newItems.length && pushOrCreateKey(payload, `${NEW_PREFIX}${LABELS}`, newItems);
  }

  if (values[FLOWS]) {
    const { newItems, userItems } = extractLists(values[FLOWS], FLOW_KEYS)
    if(!!newItems.length){
      payload = flowEnableParameters(payload, newItems[0]);
      pushOrCreateKey(payload, `${NEW_PREFIX}pre_flow`, newItems[0])
    }
    !!userItems.length && pushOrCreateKey(payload, `pre_flow`, userItems[0])
  }

  if (values[WEBHOOKS]) {
    const { userItems } = extractLists(values[WEBHOOKS], WEBHOOK_KEYS)
    let newItems = extractItemsByKeys(values[WEBHOOKS], RULE_WEBHOOK_KEYS)
    
    if(newItems && !newItems.length){
      newItems = extractItemsByKeys(values[WEBHOOKS], WEBHOOK_KEYS)
    }

    newItems = formatWebhooksHeaders(newItems);
    newItems = prepareForValidation(newItems);
    !!userItems.length && pushOrCreateKey(payload, `${WEBHOOKS}`, userItems)
    !!newItems.length &&  pushOrCreateKey(payload, `${NEW_PREFIX}${WEBHOOKS}`, newItems)
  }

  if (values[SCAN_TYPE] === SCAN_TYPE_FULL) {
    payload.type = 'full'
    payload['root_url'] = values[FULL_SCAN_ROOT_URL_FIELD]
    payload.count = values[FULL_SCAN_COUNT_FIELD]
  }
  
	if (values[SCAN_TYPE] === SCAN_TYPE_CUSTOM) {
		payload.type = "list";
		payload.pages = values[CUSTOM_SCAN_FIELD].split(/\n/)
	}

  if (values[SCAN_TYPE] === SCAN_TYPE_FLOW) {
    const { newItems, userItems } = extractLists(values[`${SCAN_PREFIX}${FLOWS}`], FLOW_SCAN_KEYS)
    if(!!newItems.length){
      payload = flowEnableParameters(payload, newItems[0], `${NEW_PREFIX}pre_flow`);
      pushOrCreateKey(payload, `${NEW_PREFIX}flow`, newItems[0])
    }
    !!userItems.length && pushOrCreateKey(payload, `flow`, userItems[0])
    payload.type = 'flow'
  }

  if (values[RULES]) {
    let userRules = extractItemsByKeys(values[RULES], USER_KEYS)
    let newRules = values.rules.filter(n => !n.id)
    payload[`${NEW_PREFIX}rules`] = newRules.map(rule => 
    {
      let ruleItem = {}
      ruleItem.name = rule[RULE_NAME]
      ruleItem.condition = rule[RULE_TRIGGER]
      ruleItem.actions = []
      if (rule[RULE_FILTERS]) {
        let newFilters = rule[RULE_FILTERS].filter(n => !n.id)
        let userItems = rule[RULE_FILTERS].filter(n => n.id)
        let mappedFilter = mapFilterRequest(newFilters)
        mappedFilter = mappedFilter.map(mf => prepareForValidation(mf))
        !!userItems.length && pushOrCreateKey(ruleItem, `filters`, userItems.map(f => f.id))
        mappedFilter && pushOrCreateKey(ruleItem, `${NEW_PREFIX}filters`, mappedFilter);
      }

      if (rule['ruleActionMailRuleAction_to']) {
        let emailArr = rule[RULE_ACTION_EMAIL_VALUE].split(',')
        ruleItem.actions.push({
          type: RULE_ACTION_TYPE_EMAIL,
          emails: emailArr
        })
      }

      if (rule[RULE_WEBHOOK_PREFIX]) {
        const webhooks = rule[RULE_WEBHOOK_PREFIX];
        let userWebhook = extractItemsByKeys(webhooks, USER_KEYS)

        let newWebhooks = extractItemsByKeys(webhooks, RULE_WEBHOOK_KEYS)
        if(newWebhooks && !newWebhooks.length){
          newWebhooks = extractItemsByKeys(webhooks, WEBHOOK_KEYS)
        }

        if (newWebhooks && newWebhooks.length) {
          newWebhooks = formatWebhooksHeaders(newWebhooks);
          newWebhooks = newWebhooks.map(nr => prepareForValidation(nr))
          pushOrCreateKey(ruleItem, `webHookRequest`, newWebhooks)
        }

        if (userWebhook && userWebhook.length) {
          userWebhook.forEach(wh => {
            ruleItem.actions.push({
              type: RULE_ACTION_TYPE_WEBHOOK,
              webhook: wh.id
            }) 
          }) 
        }

        if (ruleItem.webHookRequest && !!ruleItem.webHookRequest.length) {
          for (let i = 0; i < ruleItem.webHookRequest.length; i++) {
            ruleItem.actions.push({
              type: `${RULE_ACTION_TYPE_WEBHOOK}`,
              webhook: ruleItem.webHookRequest[i]
            })
          }
        }
      }
      delete ruleItem.webHookRequest
      return ruleItem
    })

    payload.rules = userRules.map(u => u.id);
  }

  return payload
}
